import React, { useEffect, useState, useRef, useCallback } from 'react';
import Icon from 'components/Safra/Icon';
import { Container } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';

import SearchBarPassage from 'components/Safra/SearchBarPassage';
import { NotFoundResultsPassage } from "components/Safra/NotFoundResults";
import { FlightListTile } from "components/Safra/FlightListTile";
import { LoaderSearchImage } from "components/Safra/Loader";
import Footer from 'components/Safra/Footer';
import { trackFlightSelect, trackFligthRescue } from '../../../utils/analytics';
import { getCabinClass } from '../../../utils/formatters';
import { useTranslation } from 'contexts/Safra/TranslationContext';
import { usaPontos } from '../../../utils';
import { useApp } from 'contexts/AppContext';
import { useAuth } from 'contexts/Safra/AuthProvider';
import { setSearchIdAction, setChooseIdAction, setChooseDataAction } from 'contexts/reducers/airfare/actions';

import {
    FilterSortContainer,
    FilterButton,
    FilterCountBadge,
    ResultsCount,
} from 'components/Safra/SearchAirfare/styles';

import { getFlights, chooseFlight } from '_services/airfare.service';
import { SortSelectWrapper } from 'components/Safra/SearchBarPassage/styles';

import { getOriginAirport, getDestinationAirport } from '../../../utils/airportStorage';
import { ModalApp } from 'components/Safra/Modal';

export default function PassageSearchResult() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const { airfareState, airfareDispatch } = useApp();
    const { balance } = useAuth();
    const [loading, setLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);
    const [info, setInfo] = useState(true);
    const [data, setFlights] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [order, setOrder] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [filterData, setFilterData] = useState([]);
    const [selectedFlight, setSelectedFlight] = useState(null);
    const [selectedOutboundId, setSelectedOutboundId] = useState(null);
    const [selectedInboundId, setSelectedInboundId] = useState(null);
    const [refreshKey, setRefreshKey] = useState(0);
    const [filters, setFilters] = useState({
        stops: [],
        airlines: [],
        baggage: 'all',
        priceMin: '',
        priceMax: '',
        outboundTimes: [],
        inboundTimes: []
    });
    const [isOneWay, setIsOneWay] = useState(false);
    const [choosingFlightId, setChoosingFlightId] = useState(null);
    const [chooseError, setChooseError] = useState(null);
    const wrapperRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [modalPontosMinimo, setModalPontosMinimo] = useState(false)
    const [modalSaldo, setModalSaldo] = useState(false)
    
    const [minPointsPurchase, setMinPointsPurchase] = useState(null);
    const minPoints = localStorage.getItem('minimum_value_purchase_aereo')
    const minimumPercentage = localStorage.getItem('minimum_points_payment_percentage_aereo')

    const handleModalMinimoPontos = () => {
        setModalPontosMinimo(!modalPontosMinimo);
    }

    const handleModalSaldo = () => {
        setModalSaldo(!modalSaldo);
    }

    useEffect(() => {
        if (location.state?.appliedFilters) {
            const newFilters = location.state.appliedFilters;
            setFilters(newFilters);
            setCurrentPage(1);
            setHasMore(true);
            setFlights([]);
            setFilterData([]);
            setSelectedOutboundId(null);
            setSelectedInboundId(null);
            
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location.state, navigate, location.pathname]);

    const toggleOpen = () => {
        setOpen(prev => !prev);
    };

    const handleSelect = (value) => {
        setOrder(value);
        setOpen(false);
    };

    const getLabel = () => {
        switch (order) {
        case "price-asc":
            return t('safra.common.sorting.price_asc');
        case "duration-asc":
            return t('safra.common.sorting.duration_asc');
        case "outbound-asc":
            return t('safra.common.sorting.outbound_asc');
        case "airline-asc":
            return t('safra.common.sorting.airline_asc');
        case "price-desc":
            return t('safra.common.sorting.price_desc');
        default:
            return t('safra.common.sorting.label');
        }
    };

    const parseLocalDate = (dateStr) => {
        if (!dateStr || typeof dateStr !== 'string') return null;
        const parts = dateStr.split('-');
        if (parts.length !== 3) return new Date(dateStr);
        const [year, month, day] = parts.map(Number);
        return new Date(year, month - 1, day);
    };

    const onSegmentSelect = (type, id) => {
        if (type === 'ida') {
            setSelectedOutboundId(id);
        } else {
            setSelectedInboundId(id);
        }
    };

    const handleNewSearch = () => {
        setFlights([]);
        setFilterData([]);
        setCurrentPage(1);
        setHasMore(true);
        setSelectedOutboundId(null);
        setSelectedInboundId(null);
        setRefreshKey(prev => prev + 1);
        
        // Scroll to top of page
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    const [availableAirlinesForFilter, setAvailableAirlinesForFilter] = useState([]);
    const [userBalance, setUserBalance] = useState(0);
    const [pointsRange, setPointsRange] = useState(null);
    const [apiTotalFlights, setApiTotalFlights] = useState(0);
    const [apiCabins, setApiCabins] = useState([]);

    const loadingRef = useRef(null);

    const loadMoreFlights = useCallback(() => {
        if (loading || !hasMore) return;
        setCurrentPage(prevPage => prevPage + 1);
    }, [loading, hasMore]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
            wrapperRef.current &&
            !wrapperRef.current.contains(event.target)
            ) {
            setOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const close = () => setOpen(false);
        window.addEventListener("scroll", close);

        return () => window.removeEventListener("scroll", close);
    }, []);

    useEffect(() => {
        if (!loadingRef.current) return;

        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                loadMoreFlights();
            }
        }, { threshold: 0.1 });

        observer.observe(loadingRef.current);

        return () => {
            observer.disconnect();
        };
    }, [loadMoreFlights]);

    const activeFilterCount = (() => {
        let count = 0;
        if (filters.stops?.length > 0) count++;
        if (filters.airlines?.length > 0) count++;
        if (filters.baggage !== 'all') count++;
        if (filters.priceMin || filters.priceMax) count++;
        if (filters.outboundTimes?.length > 0) count++;
        if (filters.inboundTimes?.length > 0) count++;
        return count;
    })();

    const parseDurationToMinutes = (duration) => {
        if (!duration || typeof duration !== 'string') return null;

        const normalized = duration.toLowerCase().trim();
        const hourMatch = normalized.match(/(\d+)\s*h/);
        const minMatch = normalized.match(/(\d+)\s*m/);

        if (hourMatch || minMatch) {
            const hours = hourMatch ? parseInt(hourMatch[1], 10) : 0;
            const minutes = minMatch ? parseInt(minMatch[1], 10) : 0;
            return (Number.isFinite(hours) ? hours : 0) * 60 + (Number.isFinite(minutes) ? minutes : 0);
        }

        if (normalized.includes(':')) {
            const [h, m] = normalized.split(':').map((part) => parseInt(part, 10));
            const hours = Number.isFinite(h) ? h : 0;
            const minutes = Number.isFinite(m) ? m : 0;
            return hours * 60 + minutes;
        }

        const rawNumber = parseInt(normalized.replace(/\D/g, ''), 10);
        return Number.isFinite(rawNumber) ? rawNumber : null;
    };

    const getPriceValue = (flight, missingValue) => {
        const totalPoints = Number(flight?.totalPoints);
        if (Number.isFinite(totalPoints) && totalPoints > 0) return totalPoints;

        const pointsPerAdult = Number(flight?.pointsPerAdult);
        if (Number.isFinite(pointsPerAdult) && pointsPerAdult > 0) return pointsPerAdult;

        return missingValue;
    };

    const getDateValue = (dateTime, missingValue) => {
        if (!dateTime) return missingValue;
        const value = new Date(dateTime).getTime();
        return Number.isFinite(value) ? value : missingValue;
    };

    const getTotalDuration = (flight) => {
        const outboundDuration = parseDurationToMinutes(flight?.outbound?.duration);
        if (!Number.isFinite(outboundDuration)) {
            return Number.POSITIVE_INFINITY;
        }

        const inboundDuration = parseDurationToMinutes(flight?.inbound?.duration);
        const inboundValue = Number.isFinite(inboundDuration) ? inboundDuration : 0;
        return outboundDuration + inboundValue;
    };

    const sortFlights = (flights, orderBy) => {
        if (!Array.isArray(flights) || flights.length === 0) return [];
        if (!orderBy) return flights;

        const sortedFlights = [...flights];

        switch (orderBy) {
            case 'price-asc':
                sortedFlights.sort((a, b) => (
                    getPriceValue(a, Number.POSITIVE_INFINITY) - getPriceValue(b, Number.POSITIVE_INFINITY)
                ));
                break;
            case 'price-desc':
                sortedFlights.sort((a, b) => (
                    getPriceValue(b, Number.NEGATIVE_INFINITY) - getPriceValue(a, Number.NEGATIVE_INFINITY)
                ));
                break;
            case 'duration-asc':
                sortedFlights.sort((a, b) => getTotalDuration(a) - getTotalDuration(b));
                break;
            case 'outbound-asc':
                sortedFlights.sort((a, b) => (
                    getDateValue(a?.outbound?.departure?.dateTime, Number.POSITIVE_INFINITY)
                    - getDateValue(b?.outbound?.departure?.dateTime, Number.POSITIVE_INFINITY)
                ));
                break;
            case 'outbound-desc':
                sortedFlights.sort((a, b) => (
                    getDateValue(b?.outbound?.departure?.dateTime, Number.NEGATIVE_INFINITY)
                    - getDateValue(a?.outbound?.departure?.dateTime, Number.NEGATIVE_INFINITY)
                ));
                break;
            case 'inbound-asc':
                sortedFlights.sort((a, b) => (
                    getDateValue(a?.inbound?.departure?.dateTime, Number.POSITIVE_INFINITY)
                    - getDateValue(b?.inbound?.departure?.dateTime, Number.POSITIVE_INFINITY)
                ));
                break;
            case 'inbound-desc':
                sortedFlights.sort((a, b) => (
                    getDateValue(b?.inbound?.departure?.dateTime, Number.NEGATIVE_INFINITY)
                    - getDateValue(a?.inbound?.departure?.dateTime, Number.NEGATIVE_INFINITY)
                ));
                break;
            case 'airline-asc':
                sortedFlights.sort((a, b) => {
                    const nameA = (a?.airline || '').toString().toUpperCase();
                    const nameB = (b?.airline || '').toString().toUpperCase();
                    const nameResult = nameA.localeCompare(nameB, 'pt-BR');
                    if (nameResult !== 0) return nameResult;
                    return getPriceValue(a, Number.POSITIVE_INFINITY) - getPriceValue(b, Number.POSITIVE_INFINITY);
                });
                break;
            default:
                break;
        }

        return sortedFlights;
    };

    const mapSafraToFlightTile = (recommendation, apiPointsRange) => {
        if (recommendation.outbound) return recommendation;

        const outboundFlight = recommendation.departureFlights?.[0];
        const inboundFlight = recommendation.returnFlights?.[0];

        const mapFlight = (flight) => {
            if (!flight) return null;
            const firstSegment = flight.flights?.[0];
            const lastSegment = flight.flights?.[flight.flights?.length - 1];
            return {
                departure: {
                    dateTime: flight.departureDate,
                    iataCode: flight.departureCode,
                    city: firstSegment?.departureAirport?.cityName || "",
                },
                arrival: {
                    dateTime: flight.arrivalDate,
                    iataCode: flight.arrivalCode,
                    city: lastSegment?.arrivalAirport?.cityName || "",
                },
                duration: flight.duration,
                stops: flight.stops,
                flightNumber: firstSegment?.flightNumber || ""
            };
        };

        const fareInfo = recommendation.fares;
        if (!fareInfo.length) return null;

        let pointsPerAdultValue = 0;
        let moneyPerAdultValue = 0;

        let totalPoints = 0;
        let taxInPoints = 0;
        let totalMoney = 0;
        let taxInMoney = 0;
        let totalPax = 0;

        fareInfo.map((fare) => {
            const fareAmountMoney = Number(fare.fareAmountBRL ?? fare.fareAmount ?? 0);
            const feeAmountMoney = Number(fare.feeAmountBRL ?? fare.feeAmount ?? 0);
            const taxAmountMoney = Number(fare.taxAmountBRL ?? fare.taxAmount ?? 0);

            if (fare.type === 'ADT') {
                pointsPerAdultValue = Math.ceil((fare.fareAmount + fare.feeAmount) / fare.quantity);
                moneyPerAdultValue = (fareAmountMoney + feeAmountMoney) / fare.quantity;
            }

            totalPax += fare.quantity;
            totalPoints += fare.fareAmount + fare.feeAmount;
            taxInPoints += fare.taxAmount;
            totalMoney += fareAmountMoney + feeAmountMoney;
            taxInMoney += taxAmountMoney;
        })

        const tarifaMinima = apiPointsRange?.min?.[0] || 0;

        const airlineName = outboundFlight?.company || "";
        const airlineCode = outboundFlight?.companyCode || "";

        const outboundBaggage = outboundFlight?.flights?.[0]?.baggage;
        const hasBaggage = outboundBaggage?.dispatched?.allowance !== '0P';

        return {
            id: recommendation.id,
            airline: airlineName,
            airlineCode,
            airlineLogo: airlineCode ? `https://ll-qa.s3.amazonaws.com/media/aereo/${airlineCode}.png` : "",
            pax: totalPax,
            pointsPerAdult: pointsPerAdultValue,
            totalPoints,
            tax: taxInPoints,
            moneyPerAdult: moneyPerAdultValue,
            totalMoney,
            taxMoney: taxInMoney,
            hasBaggage,
            outbound: mapFlight(outboundFlight),
            inbound: mapFlight(inboundFlight),
            raw: recommendation,
            tarifaMinima,
        };
    };

    function handleInfo() {
        setInfo(!info);
    }

    useEffect(() => {
        const fetchFlights = async () => {
            if (loading && currentPage > 1) return;
            if (!hasMore && currentPage > 1) {
                setLoading(false);
                return;
            }

            if (currentPage === 1) {
                setInitialLoading(true);
            }
            setLoading(true);
            setUserBalance(parseInt(balance) || 0);

            const origin = getOriginAirport();
            const destination = getDestinationAirport();
            const onlyDeparture = localStorage.getItem('onlyDeparture') === 'true';
            setIsOneWay(onlyDeparture);

            const fromDateStr = localStorage.getItem('from-date');
            const toDateStr = localStorage.getItem('to-date');
            const cabinClass = localStorage.getItem('class');

            const searchParams = {
                currentPage,
                departure: origin ? origin : localStorage.getItem('from-code'),
                arrival: destination ? destination : localStorage.getItem('to-code'),
                customer_uuid: localStorage.getItem('customer_parent') || '',
                dates: {
                    startDate: parseLocalDate(fromDateStr),
                    endDate: parseLocalDate(toDateStr)
                },
                passengers: {
                    adults: parseInt(localStorage.getItem('adults')) || 1,
                    children: parseInt(localStorage.getItem('children')) || 0,
                    infants: parseInt(localStorage.getItem('baby')) || 0
                },
                onlyDeparture,
                cabinClass,
                order,
                filter: filters
            };

            const response = await getFlights(searchParams);

            if (response.status && response.data.data?.recommendations) {
                const rawFlights = response.data.data?.recommendations || [];
                const apiPointsRange = response.data.data.pointsRange;
                const totalFlightsFromApi = response.data.total;

                setPointsRange(apiPointsRange);

                const cabinsFromApi = response.data.data?.cabins || [];
                setApiCabins(cabinsFromApi);

                const searchId = response.data.data.id;
                if (searchId) {
                    airfareDispatch(setSearchIdAction(searchId));
                }

                setApiTotalFlights(totalFlightsFromApi);

                const mappedFlights = rawFlights.map(rec => mapSafraToFlightTile(rec, apiPointsRange)).filter(Boolean);

               
                const companiesFromApi = response.data.data.companies || [];
                const newCompanies = companiesFromApi.map(company => ({ name: company.name.toUpperCase(), code: company.code }));

                setAvailableAirlinesForFilter(prevCompanies => {
                    const uniqueCompanies = new Map(prevCompanies.map(c => [c.code, c]));
                    newCompanies.forEach(c => uniqueCompanies.set(c.code, c));
                    return Array.from(uniqueCompanies.values()).sort((a, b) => a.name.localeCompare(b.name));
                });

                if (currentPage === 1) {
                    setFlights(mappedFlights);
                } else {
                    setFlights(prevFlights => [...prevFlights, ...mappedFlights]);
                }
                setTotalItems(totalFlightsFromApi);

                setHasMore(currentPage < response.data.last_page);
            } else {
                if (currentPage === 1) {
                    setFlights([]);
                }
                setHasMore(false);
                setTotalItems(0);
            }
            setLoading(false);
            if (currentPage === 1) {
                setInitialLoading(false);
            }
        };

        fetchFlights();
    }, [currentPage, filters, order, refreshKey]);

    useEffect(() => {
        if (!data || data.length === 0) {
            setFilterData([]);
            return;
        }
        const sortedFlights = sortFlights(data, order);
        setFilterData(sortedFlights);
    }, [data, order]);

    const handleApplyFilters = (newFilters) => {
        setFilters(newFilters);
        setCurrentPage(1);
        setHasMore(true);
        setFlights([]);
        setFilterData([]);
        setSelectedOutboundId(null);
        setSelectedInboundId(null);
    };

    const handleOrderChange = (e) => {
        setOrder(e.target.value);
        setCurrentPage(1);
        setHasMore(true);
        setFlights([]);
        setFilterData([]);
        setSelectedOutboundId(null);
        setSelectedInboundId(null);
    };

    const handleSelectFlight = async (flight) => {
        if (choosingFlightId) return;

        let balance = parseInt(localStorage.getItem('customer_balance'));
        let {totalPoints, tax} = flight
        let minimumPurchaseValue = parseInt(((totalPoints + tax) * minimumPercentage) / 100)

        setMinPointsPurchase(minimumPurchaseValue);

        if (usaPontos() && balance < minPoints) {
            handleModalMinimoPontos()
            return
        } else if (usaPontos() && minimumPurchaseValue > balance) {
            handleModalSaldo()
            return
        }

        setChoosingFlightId(flight.id);
        setChooseError(null);

        const onlyDeparture = localStorage.getItem('onlyDeparture') === 'true';
        const raw = flight.raw;

        const selectedDeparture = raw.departureFlights?.[0];
        const selectedReturn = !onlyDeparture ? raw.returnFlights?.[0] : null;

        const adults = localStorage.getItem('adults') || '1';
        const children = localStorage.getItem('children') || '0';
        const baby = localStorage.getItem('baby') || '0';

        trackFligthRescue({
            departure: localStorage.getItem('from-name') || '',
            arrival: localStorage.getItem('to-name') || '',
            depating: localStorage.getItem('from-date') || '',
            returning: localStorage.getItem('to-date') || '',
            passengers: parseInt(adults) + parseInt(children) + parseInt(baby),
            class: flight.raw?.departureFlights?.[0]?.flights?.[0]?.cabin,
            type: onlyDeparture ? 'Ida' : 'Retorno',
            adults: parseInt(adults),
            children: parseInt(children),
            baby: parseInt(baby)
        });

        const choosePayload = {
            searchId: airfareState.searchId,
            recommendationId: raw.id,
            departureId: selectedDeparture?.id,
            returnId: selectedReturn?.id || undefined,
        };

        const response = await chooseFlight(choosePayload);

        if (response.status) {
            const chooseId = response.data?.data?.chooseId;
            const chooseData = response.data?.data;

            airfareDispatch(setChooseIdAction(chooseId));
            airfareDispatch(setChooseDataAction(chooseData));

            trackFlightSelect({
                departure: localStorage.getItem('from-name') || '',
                arrival: localStorage.getItem('to-name') || '',
                depating: localStorage.getItem('from-date') || '',
                returning: localStorage.getItem('to-date') || '',
                passengers: parseInt(adults) + parseInt(children) + parseInt(baby),
                class: getCabinClass(flight.raw?.departureFlights?.[0]?.flights?.[0]?.cabin),
                type: onlyDeparture ? 'Ida' : 'Retorno',
                adults: parseInt(adults),
                children: parseInt(children),
                baby: parseInt(baby),
                points: flight.totalPoints || 0
            });

            navigate('/passage-passenger-data', {
                state: {
                    flight,
                    searchParams: {
                        fromDate: localStorage.getItem('from-date') || '',
                        toDate: localStorage.getItem('to-date') || '',
                        fromCode: localStorage.getItem('from-code') || '',
                        toCode: localStorage.getItem('to-code') || '',
                        fromName: localStorage.getItem('from-name') || '',
                        toName: localStorage.getItem('to-name') || '',
                        adults,
                        children,
                        baby,
                        onlyDeparture,
                        direct: localStorage.getItem('direct') || '0',
                        recommendationHash: localStorage.getItem('recommendation-hash') || '',
                        csrfToken: localStorage.getItem('csrf_token') || '',
                    }
                }
            });
        } else {
            setChooseError(t('safra.common.messages.error_choosing_flight'));
        }

        setChoosingFlightId(null);
    };

    const handleGoToFilter = () => {
        navigate('/passage-filter', {
            state: {
                initialFilters: filters,
                airlines: availableAirlinesForFilter
            }
        });
    };

    if (initialLoading) {
        return <LoaderSearchImage />;
    }

    return (
        <>
            <SearchBarPassage info={info} handleInfo={handleInfo} onSearch={handleNewSearch} />
            <Container>
                <FilterSortContainer>
                    <div className="left-side">
                        <div>
                            <FilterButton outline={true} width="100px" onClick={handleGoToFilter}>
                                <Icon name="filter" />
                                {' '}{t('safra.common.filters.button')} 
                                {activeFilterCount > 0 && (
                                    <FilterCountBadge>{activeFilterCount}</FilterCountBadge>
                                )}
                            </FilterButton>
                            {apiTotalFlights > 0 &&
                                <ResultsCount>
                                    {apiTotalFlights === 1 
                                        ? t('safra.common.filters.one_result_found') 
                                        : t('safra.common.filters.results_found', { count: apiTotalFlights })}
                                </ResultsCount>
                            }
                        </div>
                    </div>

                    <div className="right-side">
                        <SortSelectWrapper ref={wrapperRef}>
                            <button onClick={toggleOpen}>
                                {getLabel()}
                                <Icon name="chevron-down" className={`arrow ${open ? "open" : ""}`} />
                            </button>

                            {open && (
                                <ul>
                                <li onClick={() => handleSelect("price-asc")}>{t('safra.common.sorting.price_asc')}</li>
                                <li onClick={() => handleSelect("duration-asc")}>{t('safra.common.sorting.duration_asc')}</li>
                                <li onClick={() => handleSelect("outbound-asc")}>{t('safra.common.sorting.outbound_asc')}</li>
                                <li onClick={() => handleSelect("price-desc")}>{t('safra.common.sorting.price_desc')}</li>
                                </ul>
                            )}
                        </SortSelectWrapper>
                    </div>
                </FilterSortContainer>

                {chooseError && (
                    <div style={{
                        padding: '12px 16px',
                        marginBottom: '16px',
                        backgroundColor: '#fee',
                        border: '1px solid #fcc',
                        borderRadius: '8px',
                        color: '#c00',
                        fontSize: '14px'
                    }}>
                        {chooseError}
                    </div>
                )}

                {(() => {
                    const searchedClass = (localStorage.getItem('class') || '').toLowerCase();
                    const searchedExecutive = searchedClass.includes('business') || searchedClass.includes('executive') || searchedClass === 'executiva';
                    const searchedEconomy = !searchedExecutive;

                    const allEconomy = apiCabins.length > 0 && apiCabins.every(c => (c || '').toLowerCase().includes('economy'));
                    const allExecutive = apiCabins.length > 0 && apiCabins.every(c => !(c || '').toLowerCase().includes('economy'));

                    let message = null;
                    if (searchedExecutive && allEconomy) {
                        message = 'Não encontramos voos em Classe Executiva para essa busca. Exibindo resultados em Classe Econômica.';
                    } else if (searchedEconomy && allExecutive) {
                        message = 'Não encontramos voos em Classe Econômica para essa busca. Exibindo resultados em Classe Executiva.';
                    }

                    if (!message) return null;

                    return (
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '24px',
                            padding: '24px',
                            backgroundColor: '#FEFCE8',
                            borderRadius: '4px',
                            marginBottom: '16px',
                            marginLeft: '10px',
                            marginRight:'10px'
                        }}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
                                <circle cx="12" cy="12" r="10" stroke="#655246ff" strokeWidth="1.5"/>
                                <line x1="12" y1="8" x2="12" y2="13" stroke="#92400E" strokeWidth="1.5" strokeLinecap="round"/>
                                <circle cx="12" cy="16" r="1" fill="#92400E"/>
                            </svg>
                            <span style={{ color: '#475569', fontSize: '14px' }}>
                                {message}
                            </span>
                        </div>
                    );
                })()}

                <div className="result-content">
                    {!filterData || filterData.length === 0 ? (
                        <NotFoundResultsPassage handleInfo={handleInfo} />
                    ) : (
                        filterData.map((flight) => (
                            <FlightListTile
                                key={flight.id}
                                data={flight}
                                onSelect={handleSelectFlight}
                                isSelected={selectedFlight === flight.id}
                                onSegmentSelect={onSegmentSelect}
                                selectedOutboundId={selectedOutboundId}
                                selectedInboundId={selectedInboundId}
                                isChoosing={choosingFlightId === flight.id}
                            />
                        ))
                    )}
                </div>

                {loading && <LoaderSearchImage />}
                {!loading && hasMore && <div ref={loadingRef} style={{ height: '20px' }}></div>}

            </Container >
            <Footer />
            <ModalApp id="divModal" show={modalSaldo} handleModal={handleModalSaldo} isMap={true}>
                <div className="px-4 pt-5 pb-4 d-grid">
                    <span>{t('safra.hotel_page.messages.insufficient_points')}</span>
                    <span>{t('safra.hotel_page.messages.min_points_required', { min: minPointsPurchase })}</span>
                </div>
            </ModalApp>
            <ModalApp id="divModal" show={modalPontosMinimo} handleModal={handleModalMinimoPontos} isMap={true}>
                <div className="px-4 pt-5 pb-4 d-grid">
                    <span>{t('safra.hotel_page.messages.insufficient_points')}</span>
                    <span>{t('safra.hotel_page.messages.min_points_required', { min: minPointsPurchase })}</span>
                </div>
            </ModalApp>
        </>
    );
}
